import { useEffect, useState } from 'react';
import { Lightbulb, X } from 'lucide-react';
import { useHintStore } from '../../stores/hintStore';

export default function HintPanel() {
  const { currentHint, dismissHint } = useHintStore();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (currentHint) {
      setVisible(true);
      // Auto-dismiss low priority hints after 10 seconds
      if (currentHint.priority === 'low') {
        const timer = setTimeout(() => {
          dismissHint(currentHint.id);
        }, 10000);
        return () => clearTimeout(timer);
      }
    } else {
      setVisible(false);
    }
  }, [currentHint, dismissHint]);

  if (!currentHint) return null;

  return (
    <div
      className={`
        absolute top-3 left-1/2 -translate-x-1/2 z-30
        max-w-md w-[calc(100%-1.5rem)]
        transition-all duration-500 ease-out
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4 pointer-events-none'}
      `}
    >
      <div className="flex items-start gap-3 p-3 rounded-xl bg-slate-900/90 border border-amber-500/30 shadow-lg shadow-amber-900/10 backdrop-blur-sm">
        <div className="flex-shrink-0 mt-0.5">
          <Lightbulb className="w-5 h-5 text-amber-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm text-amber-100 leading-relaxed">{currentHint.text}</p>
        </div>
        <button
          onClick={() => dismissHint(currentHint.id)}
          className="flex-shrink-0 p-1 rounded-md hover:bg-slate-700/50 transition-colors"
          aria-label="Dismiss hint"
        >
          <X className="w-4 h-4 text-slate-400" />
        </button>
      </div>
    </div>
  );
}
